<template>
  <div id="ServicesInvoice" class="print-content">
    <div class="d-flex justify-content-between" style="color: #0056b3">
      <div>
        <h1
          style="font-size: 25px; font-weight: 800; color: #0056b3"
          class="fw-bold"
        >
          {{ $brand.nameEn }}
        </h1>
        <h2
          v-if="$brand.addressEn"
          style="font-size: 18px; font-weight: 800; color: #0056b3"
        >
          {{ $brand.addressEn }}
        </h2>
        <h2
          v-if="$brand.phone"
          style="font-size: 18px; font-weight: 800; color: #0056b3"
        >
          Mobile : {{ $brand.phone }}
        </h2>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <b-img
          class="hospital-logo"
          :src="hospitalLogo"
          width="120"
          height="120"
          />
          <!-- style="filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(200deg) brightness(104%) contrast(97%)" -->
      </div>
      <div class="" style="color: #0056b3">
        <h1
          style="font-size: 25px; font-weight: 800; color: #0056b3"
          class="w-100 d-flex justify-content-end"
        >
          {{ $brand.nameArShort }}
        </h1>
        <h2
          v-if="$brand.addressAr"
          style="font-size: 18px; font-weight: 800; color: #0056b3"
          class="w-100 d-flex justify-content-end"
        >
        {{ $brand.addressAr }}        </h2>
        <h2
          v-if="$brand.phone"
          style="font-size: 18px; font-weight: 800; color: #0056b3"
          class="w-100 d-flex justify-content-end"
        >
        {{ $brand.phone }} : موبايل
        </h2>
      </div>
    </div>

    <div
      class="mt-8 d-flex justify-content-between"
      style="margin-top: 10px; color: #0056b3"
    >
      <div
        class="d-flex justify-content-start"
        style="font-size: 23px; font-weight: 800"
      >
        Date: {{ data.date }}
      </div>
      <div
        class="d-flex justify-content-center"
        style="font-size: 23px; font-weight: 800"
      >
        65433 : رقم الحساب
      </div>
      <div
        class="d-flex justify-content-end"
        style="font-size: 23px; font-weight: 800; color: #0056b3"
      >
        {{ data.date }} :التاريخ
      </div>
    </div>

    <div style="margin-top: 20px">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <!-- <div style="font-size: 23px; font-weight: 600; color: #0056b3">
          Date:
        </div> -->
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 23px;
              text-align: center;
              font-weight: 800;
              color: #0056b3;
            "
            >{{ patientData.name }}</span
          >
        </div>
        <div style="font-size: 29px; font-weight: 800; color: #0056b3">
          :حضرة السيد
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
        "
      >
        <!-- <div style="font-size: 23px; font-weight: 600; color: #0056b3">
          Date:
        </div> -->
        <div
          style="
            border-bottom: 2px dashed #0056b3;
            flex-grow: 1;
            margin: 0 10px;
          "
        >
          <span
            class="d-flex justify-content-center"
            style="
              font-size: 23px;
              text-align: center;
              font-weight: 800;
              color: #0056b3;
            "
            >{{ data.surgery_name }}</span
          >
        </div>
        <div style="font-size: 29px; font-weight: 800; color: #0056b3">
          :اسم العملية
        </div>
      </div>
      <table
        style="
          width: 100%;
          border-collapse: collapse;
          margin: 20px auto;
          overflow: hidden;
          border: 3px solid #0056b3;
          color: #0056b3;
        "
      >
        <tr>
          <th
            style="
              padding: 6px;
              text-align: center;

              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
            "
          >
            <div style="display: flex; justify-content: space-between">
              <span style="font-size: 25px; font-weight: 800">Notes</span>
              <span style="font-size: 25px; font-weight: 800">الملاحظات</span>
            </div>
          </th>
          <th
            style="
              padding: 6px;
              text-align: center;

              border-bottom: 1px solid #0056b3;

              border-right: 1px solid #0056b3;
            "
          >
            <div style="display: flex; justify-content: space-between">
              <span style="font-size: 25px; font-weight: 800">Dinar</span>
              <span style="font-size: 25px; font-weight: 800">دينار</span>
            </div>
          </th>
          <th
            style="
              padding: 6px;
              text-align: center;

              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
            "
          >
            <div style="display: flex; justify-content: space-between">
              <span style="font-size: 25px; font-weight: 800">Services</span>
              <span style="font-size: 25px; font-weight: 800">الخدمات</span>
            </div>
          </th>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 33px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.room_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Room</span> <span>الغرفة</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.general_services_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>General Services</span> <span>خدمات عامة</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.nursing_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Nursing</span> <span>التمريض</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.consultation_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Consultationa</span> <span>الاستشارات الطببية</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.admin_services_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Admin Services</span> <span>خدمات ادارية</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.op_nurse_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Op. Nurse</span> <span>ممرضة عمليات</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.labour_room_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Labour Room</span> <span>صالة ولادة</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.surgeon_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Surgon</span> <span> الجراح</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.anesthetist_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Anesthetist</span> <span>المخدر ومساعد التخدير</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              border-right: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.medical_consumables_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #0056b3;
              border-left: 1px solid #0056b3;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Medical Consumables</span> <span>مستلزمات طبية</span>
            </div>
          </td>
        </tr>
        <!-- Repeat the below row structure for as many rows as needed -->
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.surgeon_assist_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Surgon Assist</span> <span>مساعد جراح</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.pre_incubator_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Neonate Incubator</span> <span>حاضنة خدج</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.pre_cpap_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span> CPAP</span> <span>خدج</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.tissue_transplant_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Test and Tissue Transplant</span>
              <span>تحاليل مختبرية و زرع نسيجي</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.surgery_nurse_assist_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Surgery Nurse Assist</span> <span>مساعد ممرضة جراحية</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.surgery_room_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Surgery Room</span> <span>غرفة العمليات</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.scanner_device_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Scanner Device</span> <span>جهاز الماسح الضوئي</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.anaesthetist_assist_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Anaesthetist Assist</span> <span>مساعد التخدير</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            {{ data.pre_test_amount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Pre Test</span> <span>اختبار مسبق</span>
            </div>
          </td>
        </tr>
        <tr v-if="data.discount && data.discount > 0">
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
              color: #dc3545;
            "
          >
            {{ data.discount }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Discount</span>
              <span>الخصم</span>
            </div>
          </td>
        </tr>
        <tr>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          ></td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              border-right: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
              background-color: #28a745;
              color: white;
            "
          >
            {{ calculateNetAmount() }}
          </td>
          <td
            style="
              padding: 6px;
              text-align: center;
              border-bottom: 1px solid #333;
              border-left: 1px solid #333;
              font-size: 23px;
              font-weight: 800;
            "
          >
            <div class="d-flex justify-content-between">
              <span>Net Total</span>
              <span>المجموع الصافي</span>
            </div>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-between" style="margin-top: 10px">
        <span style="font-size: 18px; font-weight: 800; color: #0056b3">
          Date In: {{patientData && patientData.patient_cards && patientData.patient_cards[0] ? patientData.patient_cards[0].created_at : 'N/A' }}</span
        >
        <span
          v-if="patientData && patientData.patient_cards && patientData.patient_cards[0] && patientData.patient_cards[0].out_date_time"
          style="font-size: 18px; font-weight: 800; color: #0056b3"
        >
          Date Out: {{ patientData && patientData.patient_cards && patientData.patient_cards[0] && patientData.patient_cards[0].out_date_time }}
        </span>
        <span v-else style="font-size: 18px; font-weight: 800; color: #0056b3">
          Date Out: المريض لم يخرج بعد
        </span>
      </div>
      <hr />
      <div class="d-flex justify-content-between">
        <span style="font-size: 25px; font-weight: 800; color: #0056b3">
          المحاسب</span
        >
        <span style="font-size: 25px; font-weight: 800; color: #0056b3">
          الغلط و السهو مرجوع للطرفين</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { BImg } from 'bootstrap-vue'
import hospitalBranding from '@/config/hospitalBranding'

export default {
  components: {
    BImg,
  },
  props: ['data', 'patientData'],
  data() {
    return {
      hospitalLogo: hospitalBranding.logo,
    }
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = 'N/A') {
      const result = path
        .split('.')
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj,
        )
      // if (typeof result === "string" && result.startsWith("\\")) {
      //   return defaultValue;
      // }
      // console.log("result", result);
      return result
    },
    
    calculateNetAmount() {
      const total = parseFloat(this.data.total_amount) || 0;
      const discount = parseFloat(this.data.discount) || 0;
      return total - discount;
    },
  },
}
</script>
<style scoped>
.print-content {
  display: none;
}
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
/* Show the print content when printing */
@media print {
  .print-content {
    display: block;
  }
  button {
    display: none; /* Hide the button when printing */
  }
}
p.solid {
  border-style: solid;
}
table {
  background-color: #333;
  width: 60%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  border: 3px solid #333;
}
th,
td {
  padding: 6px;
  text-align: center;
  border-bottom: 1px solid #333;
}
th {
  background-color: #f2f2f2;
}
tr:last-child td {
  border-bottom: none;
}
</style>
<!--  -->
